export const serviceTypePhotos: Record<string, string> = {
  "Roofing": "/images/roofing.jpg",
  "Plumbing": "/images/plumbing.jpg",
  "HVAC": "/images/hvac.jpg",
  "Electrical": "/images/electrical.jpg",
  "Landscaping": "/images/landscaping.jpg",
  "Painting": "/images/painting.jpg",
  "Concrete": "/images/concrete.jpg",
  "General Contracting": "/images/general-contracting.jpg",
  "Remodeling": "/images/remodeling.jpg",
  "Flooring": "/images/flooring.jpg",
  "Fencing": "/images/fencing.jpg",
  "Windows": "/images/windows.jpg"
};

// Fallback images from the provided set
export const fallbackImages = {
  laptop: "/images/laptop-workspace.jpg",  // photo-1486312338219-ce68d2c6f44d
  office: "/images/office-desk.jpg",       // photo-1581091226825-a6a2a5aee158
  lightbulb: "/images/lightbulb.jpg"       // photo-1581090464777-f3220bbe1b8b
};